import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronLeft, ChevronRight } from 'lucide-react';
const IMAGES = ['https://cdn.magicpatterns.com/uploads/b2ZJKPkSjXNUbW317DGKuE/Captura_de_pantalla_2026-03-08_005025.png', 'https://cdn.magicpatterns.com/uploads/5ThCQdS59GgPJ285HoRJLq/Captura_de_pantalla_2026-03-08_005035.png', 'https://cdn.magicpatterns.com/uploads/2B1NmgeZm5uCWxnFpCfKSC/Captura_de_pantalla_2026-03-08_005051.png', 'https://cdn.magicpatterns.com/uploads/13jNUDVAWfHtnZfQr976Td/Captura_de_pantalla_2026-03-08_005128.png', 'https://cdn.magicpatterns.com/uploads/kWvmxMRQJs1fYK3w1AyUxb/Captura_de_pantalla_2026-03-08_005141.png'];
const variants = {
  enter: (direction: number) => {
    return {
      x: direction > 0 ? 1000 : -1000,
      opacity: 0
    };
  },
  center: {
    zIndex: 1,
    x: 0,
    opacity: 1
  },
  exit: (direction: number) => {
    return {
      zIndex: 0,
      x: direction < 0 ? 1000 : -1000,
      opacity: 0
    };
  }
};
const swipeConfidenceThreshold = 10000;
const swipePower = (offset: number, velocity: number) => {
  return Math.abs(offset) * velocity;
};
export function ProductCarousel() {
  const [[page, direction], setPage] = useState([0, 0]);
  const [isHovered, setIsHovered] = useState(false);
  // We only have 5 images, so we wrap the index
  const imageIndex = Math.abs(page % IMAGES.length);
  const paginate = (newDirection: number) => {
    setPage([page + newDirection, newDirection]);
  };
  useEffect(() => {
    if (isHovered) return;
    const timer = setInterval(() => {
      paginate(1);
    }, 3500);
    return () => clearInterval(timer);
  }, [isHovered, page]);
  return <section className="py-16 px-4 bg-[#FFF8E1]" data-id="element-207">
      <div className="max-w-4xl mx-auto" data-id="element-208">
        <div className="relative max-w-2xl mx-auto bg-white rounded-3xl shadow-xl overflow-hidden border border-yellow-100" onMouseEnter={() => setIsHovered(true)} onMouseLeave={() => setIsHovered(false)} data-id="element-209">
          {/* Carousel Container */}
          <div className="relative aspect-[4/5] md:aspect-square w-full bg-gray-50 flex items-center justify-center overflow-hidden" data-id="element-210">
            <AnimatePresence initial={false} custom={direction} data-id="element-211">
              <motion.img key={page} src={IMAGES[imageIndex]} custom={direction} variants={variants} initial="enter" animate="center" exit="exit" transition={{
              x: {
                type: 'spring',
                stiffness: 300,
                damping: 30
              },
              opacity: {
                duration: 0.2
              }
            }} drag="x" dragConstraints={{
              left: 0,
              right: 0
            }} dragElastic={1} onDragEnd={(e, {
              offset,
              velocity
            }) => {
              const swipe = swipePower(offset.x, velocity.x);
              if (swipe < -swipeConfidenceThreshold) {
                paginate(1);
              } else if (swipe > swipeConfidenceThreshold) {
                paginate(-1);
              }
            }} className="absolute w-full h-full object-contain p-4 md:p-8" alt={`Vista interior del producto ${imageIndex + 1}`} data-id="element-212" />
            </AnimatePresence>
          </div>

          {/* Navigation Arrows */}
          <button className="absolute left-4 top-1/2 -translate-y-1/2 bg-white/80 hover:bg-white text-gray-800 p-2 rounded-full shadow-md backdrop-blur-sm transition-all z-10" onClick={() => paginate(-1)} aria-label="Imagen anterior" data-id="element-213">
            <ChevronLeft className="w-6 h-6" data-id="element-214" />
          </button>
          <button className="absolute right-4 top-1/2 -translate-y-1/2 bg-white/80 hover:bg-white text-gray-800 p-2 rounded-full shadow-md backdrop-blur-sm transition-all z-10" onClick={() => paginate(1)} aria-label="Siguiente imagen" data-id="element-215">
            <ChevronRight className="w-6 h-6" data-id="element-216" />
          </button>

          {/* Dots */}
          <div className="absolute bottom-4 left-0 right-0 flex justify-center gap-2 z-10" data-id="element-217">
            {IMAGES.map((_, idx) => <button key={idx} onClick={() => {
            const newDirection = idx > imageIndex ? 1 : -1;
            setPage([page + (idx - imageIndex), newDirection]);
          }} className={`w-2.5 h-2.5 rounded-full transition-all ${idx === imageIndex ? 'bg-blue-600 w-6' : 'bg-gray-300 hover:bg-gray-400'}`} aria-label={`Ir a la imagen ${idx + 1}`} data-id="element-218" />)}
          </div>
        </div>

        {/* Heading Below */}
        <div className="text-center mt-12" data-id="element-219">
          <h2 className="text-3xl md:text-4xl font-black text-gray-900 mb-4 uppercase tracking-tight" data-id="element-220">
            Todo lo que necesitás para tus niños
          </h2>
          <p className="text-lg text-gray-600 font-medium max-w-2xl mx-auto" data-id="element-221">
            Un vistazo por dentro a los materiales diseñados para que aprendan
            jugando y sin frustraciones.
          </p>
        </div>
      </div>
    </section>;
}